import React, { Component } from 'react'
import Auth from '../common/Auth'
import Config from '../Config'
import jsPDF from "jspdf"
import request from "request"
import $ from 'jquery'
import axios from 'axios'
import ReactDOM from 'react-dom'
import base64Img from 'base64-img'
import DrawDataList from './DrawDataList'

const colstyle = {
    fontSize:'30px',
    display:'none'
}

function showReport(img, row, data, comp){
    const pdf = new jsPDF("l", "mm", "a4")
    const columns = [{title:"Ticket Number", dataKey:"ticketSerial"}, {title:"Timestamp", dataKey:"createdon"}, 
    {title:"Agent", dataKey:"agent"}, {title:"Retailer", dataKey:"retailer"}, 
    {title:"Bets", dataKey:"bets"}, {title:"Lines", dataKey:"noOfLines"}, 
    {title:"Stake Number", dataKey:"stakeNum"}, {title:"Line Total", dataKey:"lineTotal"}]

    pdf.setProperties({
        title: data.title + ' for ' + data.gamename,
        subject: data.title + ' for ' + data.gamename,
        author: comp.companyName,
        keywords: 'draw, screen, alpha, lotto',
        creator: 'Mojave Consultancy'
    })

    pdf.autoTable({
        html: '#tbCompany', 
        theme: 'plain',
        styles: {fontSize: 18, fontStyle:'bold', overflow: 'linebreak'},
        columnStyles: {
            0 :{cellWidth:50}, 
            1: {halign: 'center'}, 
            2: {halign:'right', valign:'bottom', cellWidth:40, fontSize:8, fontStyle:'normal'}
        }
    })

    if(img !='' && img !=undefined){
        let tp = 'PNG'
        if(img.indexOf('jpeg') != -1 && img.indexOf('jpg') != -1){
            tp = 'JPEG'
        }
        pdf.addImage(img,tp,15,10,0,23)
    }
    pdf.line(14, 40, 282, 40)
    pdf.autoTable({
        html: '#tbTitles', 
        theme: 'striped',
        //styles: {fontSize: 18, fontStyle:'bold', overflow: 'linebreak'},
        columnStyles: {
            0 :{halign:'right', cellWidth:35}, 1: {fontStyle: 'bold', cellWidth:45},
            2 :{halign:'right', cellWidth:40}, 3: {fontStyle: 'bold', cellWidth:45}
        }
    })

    pdf.autoTable(columns, row, {
        theme : 'striped',
        styles: {overflow: 'linebreak'},
        headStyles: {halign:'center'},
        columnStyles: {
            noOfLines: {halign:'center',cellWidth:15}, 
            lineTotal: {halign:'right',cellWidth:35},
            ticketSerial: {cellWidth:45},
            createdon: {cellWidth:45},
            agent: {cellWidth:15},
            retailer: {cellWidth:20},
            bets: {cellWidth:20}
        },
        margin: { top: 46 }
    })

    var data = pdf.output('datauristring')
    document.getElementById('pdfPreview').src = data
}

export default class DrawDataPrint extends Component{
    constructor(props){
        super(props)

        this.auth = new Auth()
        this.config = new Config()
        this.$http = this.config.DConnect()

        this.state = {
            rowData: this.props.rowData,
            data: this.props.data,
            companySetup:''
        }
    }

    componentDidMount(){
        this.generatePDF()
    }

    componentDidUpdate(nextProps){
        if(nextProps.rowData !== this.props.rowData){
            let rowData = nextProps.rowData
            let data = nextProps.data

            this.setState({ rowData, data })

            this.generatePDF()
        }
    }

    generatePDF = () => {
        this.$http.get('admin/wapp/setup')
        .then(res => {
            let companySetup = this.auth.decryptData(res.data)
            let url = 'admin/wapp/image/custfiles/' + companySetup.logo

            this.setState({ companySetup })
            let rowData = this.state.rowData
            let data = this.state.data

            //alert(JSON.stringify(rowData))
            this.$http.get(url, {responseType: 'arraybuffer'})
            .then((res) => {
                let img = new Buffer(res.data, 'binary').toString('base64')
                showReport(img, rowData, data, companySetup)
            }).catch((error)=>{showReport('', rowData, data, companySetup)})
        })
    }

    goBack = () => {
        ReactDOM.render(
            <DrawDataList  />,
            document.getElementById('drawDataCon')
        )
    }

    render(){
        let dt = this.state.data
        
        return(
            <div className="row">
                <div className="col-xs-12 col-sm-10">
                    <iframe id="pdfPreview" type="application/pdf" style={{ 'width': '100%', 'height': '550px', 'border': 'none' }}></iframe>
                </div>
                <div className="col-xs-12 col-sm-2">
                    <div className="btn-group btn-group-vertical btn-group-sm">
                        <button className="btn btn-warning" onClick={this.goBack}> 
                            <i className="fa fa-backward"></i> Back
                        </button>
                        <button className="btn btn-success"> <i className="fa fa-file-excel-o"></i> Export Excel</button>
                        <button className="btn btn-success"> <i className="fa fa-file-archive-o"></i> Export CSV</button>
                    </div>
                </div>
                <div className="col-xs-12">
                    <table id="tbCompany" className="table table-condensed" style={colstyle}>
                        <tbody>
                            <tr>
                                <td rowSpan="3"></td>
                                <td>{this.state.companySetup.companyName}</td>
                                <td rowSpan="3">
                                    P.O.Box: 16244 KIA <br />TEL:0302 2232 143 <br />ACCRA-GHANA
                                </td>
                            </tr>
                            <tr>
                                <td>{this.state.data.title}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table id="tbTitles" className="table table-condensed" style={colstyle}>
                        <tbody>
                            <tr>
                                <td>Game Name: </td><td>{dt.gamename}</td>
                                <td>Event Number: </td><td>{dt.event}</td>
                            </tr>
                            <tr>
                                <td>Draw Date: </td><td>{dt.drawDate}</td>
                                <td>Total Bets: </td><td>{dt.totalbets}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}